// HubSpot calling extension (plan B6): the embedded calling page's sign-in (popup ticket → embed token), its context,
// the LIA call ↔ HubSpot engagement mapping, and the platform registration of the extension's calling settings.
import * as H from './api-hubspot-calling.js';
import { OkSchema } from './api.js';
import { IdParam, route, W, Ws } from './route-def.js';

export const hubspotCallingRoutes = {
  createHubspotEmbedTicket: route({
    method: 'POST', path: '/workspaces/:workspaceId/hubspot-calling/tickets', summary: 'HubSpot: boleto de un solo uso para iniciar sesión en la extensión de llamadas', tag: 'hubspot-calling',
    minRole: 'advisor', params: Ws, response: H.HubspotEmbedTicketSchema, status: 201,
  }),
  exchangeHubspotEmbedTicket: route({
    method: 'POST', path: '/hubspot-calling/session', summary: 'HubSpot: cambiar el boleto por un token de la extensión (solo memoria)', tag: 'hubspot-calling',
    public: 'auth', body: H.ExchangeHubspotEmbedTicketSchema, response: H.HubspotEmbedSessionSchema, status: 201,
  }),
  endHubspotEmbedSession: route({
    method: 'POST', path: '/workspaces/:workspaceId/hubspot-calling/session/end', summary: 'HubSpot: cerrar la sesión de la extensión', tag: 'hubspot-calling',
    minRole: 'advisor', params: Ws, response: OkSchema,
  }),
  getHubspotCallingContext: route({
    method: 'GET', path: '/workspaces/:workspaceId/hubspot-calling/context', summary: 'HubSpot: portales conectados y estado de la extensión', tag: 'hubspot-calling',
    minRole: 'advisor', params: Ws, response: H.HubspotCallingContextSchema,
  }),
  linkHubspotCallEngagement: route({
    method: 'PUT', path: '/workspaces/:workspaceId/hubspot-calling/calls/:callId/engagement', summary: 'HubSpot: vincular la llamada con su interacción (idempotente)', tag: 'hubspot-calling',
    minRole: 'advisor', params: W({ callId: IdParam }), body: H.LinkHubspotCallEngagementSchema, response: H.HubspotCallEngagementSchema,
  }),
  getHubspotCallingRegistration: route({
    method: 'GET', path: '/platform/hubspot-calling', summary: 'HubSpot: registro de la extensión de llamadas de la app pública', tag: 'platform',
    capability: 'platform_integration_admin', response: H.HubspotCallingRegistrationSchema,
  }),
  registerHubspotCalling: route({
    method: 'POST', path: '/platform/hubspot-calling/register', summary: 'HubSpot: registrar la extensión de llamadas (calling settings)', tag: 'platform',
    capability: 'platform_integration_admin', body: H.RegisterHubspotCallingSchema, response: H.HubspotCallingRegistrationSchema,
  }),
} as const;
